export function ParticipationIcon() {
  const svgPath =
    'M10.5 13C13.5376 13 16 15.4624 16 18.5C16 18.516 16.0001 18.5319 16 18.5479C15.9978 18.8039 ' +
    '15.7815 18.9999 15.5254 19H15.4736C15.2063 19 15 18.7673 15 18.5C15 16.0147 12.9853 14 10.5 ' +
    '14H7.5C5.01472 14 3 16.0147 3 18.5C3 18.7673 2.79368 19 2.52637 19H2.47461C2.21854 18.9999 ' +
    '2.0022 18.8039 2 18.5479C1.99986 18.5319 2 18.516 2 18.5C2 15.4624 4.46243 13 7.5 13H10.5ZM16.5 ' +
    '13C19.5376 13 22 15.4624 22 18.5C22 18.7761 21.7761 19 21.5 19C21.2239 19 21 18.7761 21 18.5C21 ' +
    '16.0147 18.9853 14 16.5 14H15.5C15.2239 14 15 13.7761 15 13.5C15 13.2239 15.2239 13 15.5 13H16.5ZM9 ' +
    '4C11.2091 4 13 5.79086 13 8C13 10.2091 11.2091 12 9 12C6.79086 12 5 10.2091 5 8C5 5.79086 6.79086 4 ' +
    '9 4ZM15.2109 5.01172C15.8814 4.95616 16.5539 5.09546 17.1475 5.41211C17.7411 5.72882 18.2313 6.20997 ' +
    '18.5586 6.79785C18.8857 7.38562 19.0357 8.05532 18.9922 8.72656C18.9486 9.39803 18.7131 10.0433 ' +
    '18.3125 10.584C17.9119 11.1246 17.3631 11.5382 16.7334 11.7754C16.1038 12.0125 15.4193 12.0628 ' +
    '14.7617 11.9209C14.4367 11.8507 14.1245 11.7356 13.835 11.5791C13.6788 11.4947 13.5296 11.3975 ' +
    '13.3877 11.29C13.176 11.1298 13.1775 10.8225 13.3652 10.6348C13.553 10.4472 13.8555 10.4516 14.0752 ' +
    '10.6006C14.3433 10.7824 14.6453 10.9125 14.9648 10.9814C15.4416 11.0843 15.9381 11.0478 16.3945 ' +
    '10.876C16.851 10.704 17.2485 10.4036 17.5391 10.0117C17.8295 9.61971 18.0015 9.1519 18.0332 ' +
    '8.66504C18.0648 8.17807 17.9551 7.69202 17.7178 7.26562C17.4804 6.8392 17.1249 6.49044 16.6943 ' +
    '6.26074C16.2638 6.03109 15.7764 5.93035 15.29 5.9707C14.9644 5.99773 14.6486 6.08692 14.3594 ' +
    '6.23242C14.1222 6.35178 13.8211 6.31692 13.6592 6.10645C13.4975 5.89598 13.536 5.59144 13.7666 ' +
    '5.45996C13.9213 5.37176 14.0822 5.29498 14.248 5.23145C14.5553 5.11375 14.8796 5.03921 15.2109 ' +
    '5.01172ZM9 5C7.34315 5 6 6.34315 6 8C6 9.65685 7.34315 11 9 11C10.6569 11 12 9.65685 12 8C12 ' +
    '6.34315 10.6569 5 9 5Z';

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d={svgPath} fill="currentColor" />
    </svg>
  );
}
